import axios from 'axios'
import { BASE_API } from '@/config'
import { Message } from 'element-ui'
import store from '@/store/index'
// 创建axios实例
const service = axios.create({
	baseURL: BASE_API,
	timeout: 30000, // 请求超时时间
	withCredentials: true,
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
	}
})
// request拦截器
service.interceptors.request.use(
	config => {
		const options = config.method === 'get' ? config.params : config.data
		// post-body数据转为FormData格式
		const formData = new FormData()
		for (const k in options) {
			formData.append(k, options[k])
		}
		config.data = formData
		config.headers.token = store.getters.token
		return config
	},
	error => {
		Promise.reject(error)
	}
)

// response 拦截器
service.interceptors.response.use(
	response => {
		const res = response.data
		if (res.status === 10000) {
			return Promise.resolve(res.data)
		} else if (res.status === 10002) {
			// 登录过期
			Message({
				message: '登陆失效',
				type: 'error',
				duration: 3 * 1000
			})
			store.dispatch('quitLogin').then(() => {
				location.reload() // 为了重新实例化vue-router对象 避免bug
			})
		} else {
			Message({
				message: response.data.msg || '服务器错误',
				type: 'error',
				duration: 3 * 1000
			})
			return Promise.reject(response)
		}
	},
	error => {
		Message({
			message: '服务器内部错误',
			type: 'error',
			duration: 3 * 1000
		})
		console.log('err' + error)
		return Promise.reject(error)
	}
)

export default (path, data = {}, method = 'post') => {
	if (method === 'post') {
		return service.post(path, data)
	} else {
		return service.get(path, { params: data })
	}
}
